import React, { useState } from 'react';
import styles from '../../../styles/common/common-styles.module.scss';
import { useSelector } from 'react-redux';
import { getAddressLine } from '../../../utils/AddressHelper';

const Accordion1 = props => {
  const personData = useSelector(state => state.person);
  return (
    <div className={styles.accordionDetails}>
      {console.log(personData)}

      {/* Registered details */}
      <h3 className={`${styles.sectionTitle} ${styles.noBorder}`}>Registered details</h3>
      <div className={`row ${styles.row}`}>
        <div className={`col-md-4 ${styles.label}`}>Name</div>
        <div className={`col-md-8 ${styles.value}`} translate="no">
          {personData?.firstname} {personData?.middlename} {personData?.lastname}
        </div>
      </div>
      <div className={`row ${styles.row}`}>
        <div className={`col-md-4 ${styles.label}`}>Place of death</div>
        <div className={`col-md-8 ${styles.value}`} translate="no">
          {personData?.deceasedState?.label}
        </div>
      </div>
      <div className={`row ${styles.row}`}>
        <div className={`col-md-4 ${styles.label}`}>Date of death</div>
        <div className={`col-md-8 ${styles.value}`} translate="no">
          {personData?.dayOfDeath}-{personData?.monthOfDeath}-{personData?.yearOfDeath}
        </div>
      </div>
      <div className={`row ${styles.row}`}>
        <div className={`col-md-4 ${styles.label}`}>Date of birth</div>
        <div className={`col-md-8 ${styles.value}`} translate="no">
          {personData?.dayOfBirth}-{personData?.monthOfBirth}-{personData?.yearOfBirth}
        </div>
      </div>

      {/* Property details */}
      <h3 className={styles.sectionTitle}>Property details</h3>
      <div className={`row ${styles.row}`}>
        <div className={`col-md-4 ${styles.label}`}>Residential address</div>
        <div className={`col-md-8 ${styles.value}`} translate="no">
          {personData?.currentAddress ? getAddressLine(personData?.currentAddress) : null}
        </div>
      </div>
      <div className={`row ${styles.row}`}>
        <div className={`col-md-4 ${styles.label}`}>Ownership</div>
        <div className={`col-md-8 ${styles.value}`} translate="no">
          {personData?.ownHome?.label}
        </div>
      </div>
      <div className={`row ${styles.row}`}>
        <div className={`col-md-4 ${styles.label}`}>Additional property</div>
        <div className={`col-md-8 ${styles.value}`} translate="no">
          {personData?.ownedPropertyAddresses?.map(a => {
            if (a && Object.keys(a).length !== 0) {
              return <div>{getAddressLine(a)}</div>;
            } else {
              return <div>Not applicable</div>;
            }
          })}
        </div>
      </div>
      <a
        className={styles.editLink}
        tabIndex="0"
        href="javascript:void(0)"
        onKeyPress={event => {
          if (event.key === 'Enter') {
            props.history.push('/deceased-info?id=1');
          }
        }}
        onClick={() => {
          props.history.push('/deceased-info?id=1');
        }}
      >
        Edit property details
      </a>

      {/* Business details */}
      <h3 className={styles.sectionTitle}>Business details</h3>
      {personData?.businessArray.length > 0 &&
        personData?.businessArray.map(b => (
          <div className={`row ${styles.row}`}>
            <div className={`col-md-4 ${styles.label}`}>Registered business</div>
            <div className={`col-md-8 ${styles.value}`} translate="no">
              {b?.businessName} - ABN {b?.abn}
            </div>
          </div>
        ))}

      {personData?.businessArray.length === 0 && (
        <div className={`row ${styles.row}`}>
          <div className={`col-md-4 ${styles.label}`}>Registered business</div>
          <div className={`col-md-8 ${styles.value}`} translate="no">
            Not applicable
          </div>
        </div>
      )}

      <a
        tabIndex="0"
        href="javascript:void(0)"
        onKeyPress={event => {
          if (event.key === 'Enter') {
            props.history.push('/deceased-info?id=2');
          }
        }}
        className={styles.editLink}
        onClick={() => {
          props.history.push('/deceased-info?id=2');
        }}
      >
        Edit business details
      </a>

      {/* Additional information */}
      <h3 className={styles.sectionTitle}>Additional information</h3>
      <div className={`row ${styles.row}`}>
        <div className={`col-md-4 ${styles.label}`}>Email</div>
        <div className={`col-md-8 ${styles.value}`} translate="no">
          {personData?.deceasedEmailAddress?.join(', ')}
        </div>
      </div>
      <div className={`row ${styles.row}`}>
        <div className={`col-md-4 ${styles.label}`}>Phone</div>
        <div className={`col-md-8 ${styles.value}`} translate="no">
          {personData?.contactNumber?.join(', ')}
        </div>
      </div>
      <div className={`row ${styles.row}`}>
        <div className={`col-md-4 ${styles.label}`}>Other name</div>
        <div className={`col-md-8 ${styles.value}`} translate="no">
          {personData?.otherNamesArray[0]?.firstName || 'Not applicable'}
        </div>
      </div>
      <div className={`row ${styles.row}`}>
        <div className={`col-md-4 ${styles.label}`}>Other last name</div>
        <div className={`col-md-8 ${styles.value}`} translate="no">
          {personData?.otherNamesArray[0]?.lastName || 'Not applicable'}
        </div>
      </div>
      <a
        tabIndex="0"
        href="javascript:void(0)"
        onKeyPress={event => {
          if (event.key === 'Enter') {
            props.history.push('/deceased-info?id=3');
          }
        }}
        className={styles.editLink}
        onClick={() => {
          props.history.push('/deceased-info?id=3');
        }}
      >
        Edit additional information
      </a>
    </div>
  );
};

export default Accordion1;
